import { render } from "./ConsultantsIcon.vue?vue&type=template&id=1bd49060"
import script from "./ConsultantsIcon.vue?vue&type=script&lang=js"
export * from "./ConsultantsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__